export type IntelligenceMode = 'full' | 'lite';
export type IntelligenceModeProject = { intelligence_mode?: IntelligenceMode | null };

export function getIntelligenceMode(
  project: IntelligenceModeProject | null | undefined
): IntelligenceMode {
  return project?.intelligence_mode === 'lite' ? 'lite' : 'full';
}

export function isLiteProject(project: IntelligenceModeProject | null | undefined): boolean {
  return getIntelligenceMode(project) === 'lite';
}

/** Only newly created projects explicitly opt into initial mode selection. */
export function resolveIntelligenceMode(
  project: IntelligenceModeProject,
  requested?: unknown
): IntelligenceMode {
  if (requested !== undefined && requested !== 'full' && requested !== 'lite') {
    throw new Error('Invalid Intelligence mode');
  }
  const mode = requested ?? getIntelligenceMode(project);
  if (project.intelligence_mode !== null && mode !== getIntelligenceMode(project)) {
    throw new Error('Intelligence mode cannot be changed after project setup');
  }
  return mode as IntelligenceMode;
}

// SQL preparations can hold the full 1,500-prompt inventory, including UTF-8 text.
export const INTELLIGENCE_SETUP_MAX_BYTES = 8 * 1024 * 1024;
export function intelligenceSetupRequestLimit() {
  return INTELLIGENCE_SETUP_MAX_BYTES;
}

export function intelligenceCapabilities(project: IntelligenceModeProject | null | undefined) {
  const lite = isLiteProject(project);
  return {
    rawCitations: true,
    publisherClassification: true,
    pageAnalysis: !lite,
    outreach: !lite,
  };
}

/** Must match the recurring scheduler's stable project hour. */
export function getLiteAssignedHour(projectId: string): number {
  let hash = 0;
  for (let i = 0; i < projectId.length; i++) {
    hash = (hash << 5) - hash + projectId.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash) % 24;
}
